<template>
  <div class="statistics" v-if="canBeDisplayedAtTheCurrentLink">
    <div class="statistics-content">
      <div class="statistics-left-side-data">
        <div v-if="$i18n.locale == 'zh-CN'" v-for="(item, index) in statisticsOfRoomStatus" :key="index"
          :style="index == statisticsOfRoomStatus.length - 1 ? 'border:0px' : ''">
          {{ item.i18nName }}：{{ item.itemValue }}{{ item.code == 'todayRentalRate' || item.code == 'fullDayOcc' ? '%' :
            '' }}
        </div>
      </div>

      <div class="statistics-right-side-data">
        <div class="details" @click="getHotelStateDate">{{ $t('roomStatusStatistics.details') }}</div>
        <div @click="goBusinessDay">{{ $t('common.businessDay') }}:{{ businessDay }}</div>
      </div>

      <HotelStateDialog v-model="hotelStateDialogVisible" :roomCountList="roomCountListDialog"></HotelStateDialog>
    </div>
  </div>
</template>

<script>
import { getHotelState } from '@/api/realTime.js';
export default {
  components: {
    HotelStateDialog: () => import('@/views/room-status/real-time/components/HotelStateDialog.vue'),
  },

  data() {
    return {
      statisticsOfRoomStatus: [],
      hotelStateDialogVisible: false,
      roomCountListDialog: [],
    };
  },
  computed: {
    businessDay() {
      return this.$store.state.user.businessDay;
    },
    canBeDisplayedAtTheCurrentLink() {
      let arr = ['/tabpage'];
      return arr.indexOf(this.$route.path) == -1;
    }
  },
  mounted() {
    this.fetchHotelState();
  },
  watch: {
    '$store.state.app.isNeedRefreshStatistics'(newVal, oldVal) {
      this.fetchHotelState();
    },
  },
  methods: {
    /* 查询底部房间状态统计*/
    async fetchHotelState(type) {
      let data = await this.awaitWrapper(getHotelState());
      const targetNames = ['inHouseRooms', 'unavailable', 'totalRoomNum'];
      const targetItems = targetNames
        .map((code) => data.find((item) => item.code === code))
        .filter((item) => item);
      const names = targetItems.map((item) => item.i18nName).join('/');
      const values = targetItems.map((item) => item.itemValue ?? '0').join('/');
      // 创建拼接后的新项
      const combinedItem = {
        name: names,
        i18nName: names,
        value: null,
        itemValue: values,
        color: null,
        img: null,
      };
      const updatedList = [
        combinedItem,
        ...data.filter((item) => !targetNames.includes(item.code)),
      ];
      this.roomCountListDialog = data;
      this.statisticsOfRoomStatus = updatedList;
    },
    getHotelStateDate() {
      this.fetchHotelState();
      this.hotelStateDialogVisible = true;
    },
    // 营业日跳转
    goBusinessDay() {
      this.$router.push({ path: '/operate-log/business' });
    },
  },
};
</script>
<style lang="scss" scoped>
.statistics {
  height: 40px;
  line-height: 40px;
  box-sizing: border-box;
  padding-left: 8px;
  padding-right: 8px;
  border-left: 12px solid #f0f1f7;

  .statistics-content {
    display: flex;
    justify-content: space-between;
  }

  .statistics-left-side-data {
    flex: 1;
    max-width: 1200px;
    display: flex;
    justify-content: space-around;
    align-items: center;
    scrollbar-width: none;
    /* Firefox 隐藏滚动条 */
    -ms-overflow-style: none;
    /* IE/Edge 隐藏滚动条 */

    div {
      flex: 1;
      min-width: max-content;
      /* 不让文字被压缩 */
      text-align: center;
      /* 居中可选 */
      height: 15px;
      font-weight: 500;
      font-size: 12px;
      color: #23253a;
      line-height: 15px;
      padding: 0 5px;
      border-right: 1px solid #23253a;
    }
  }

  .statistics-right-side-data {
    display: flex;
    justify-content: space-around;
    width: 200px;
    text-align: right;
    font-weight: 500;
    font-size: 12px;
    color: #999999;
    cursor: pointer;

    .details {
      color: #0068b6;
    }

    .details:hover {
      color: #8aafd4;
    }
  }
}
</style>
